import styled from '@emotion/styled';

export const BaseMessageButton = styled.button(({ theme }) => ({
  borderRadius: 15,

  color: theme.palette.badge.citation.color,
  backgroundColor: theme.palette.badge.citation.bg,
  fontFamily: theme.fonts.semiBold,
  padding: `5px 8px`,
  minWidth: 80,
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
  height: 30,

  '&:hover': {
    color: theme.palette.badge.citation.color,
    backgroundColor: theme.palette.badge.citation.hover.bg,
    borderColor: theme.palette.badge.citation.hover.bg,
  },

  '&:disabled': {
    cursor: 'initial',
    color: theme.palette.btnPrimary.disabled.color,
    backgroundColor: theme.palette.btnPrimary.disabled.bg,
    borderColor: theme.palette.btnPrimary.disabled.border,
  },
}));
